export default {"src":"/_next/static/media/favicon.034a7a8c.svg","height":938,"width":938,"blurWidth":0,"blurHeight":0};